<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>
<!-- Navigation Menu -->
<nav class="navbar navbar-expand-lg fixed-top shadow-sm py-2" style="background-color: rgba(255, 255, 255, 0.95);">
  <div class="container-fluid px-5">
    <a href="#">
      <img src="assets/images/logo.png" alt="E-Cidadanias Logo" height="80">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav align-items-center">
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('servicos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Serviços</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('como-funciona')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Como Funciona</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('depoimentos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Depoimentos</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('contato')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Contato</a>
        </li>
        <li class="nav-item ms-3">
          <button class="btn btn-outline-dark px-4 fw-medium" style="font-size: 1.05rem; border-width: 2px; transition: all 0.3s ease;" (click)="login()">Login</button>
        </li>
      </ul>
    </div>
  </div>
</nav>

<style>
.nav-link:hover {
  color: #666 !important;
}

.btn-outline-dark:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  background-color: #333;
  color: white;
}

.navbar {
  border-bottom: 1px solid rgba(0,0,0,0.05);
  backdrop-filter: blur(5px);
}

.stat-number {
  color: #153658;
  font-size: 2.5rem;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(21, 54, 88, 0.1);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #153658 0%, #1a4370 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  color: #153658;
  font-size: 1rem;
  font-weight: 500;
  display: block;
  opacity: 0.8;
}

.stat-item {
  text-align: center;
  padding: 1.5rem;
  transition: all 0.3s ease;
  border-radius: 12px;
  background: rgba(21, 54, 88, 0.02);
  border: 1px solid rgba(21, 54, 88, 0.05);
}

.stat-item:hover {
  background: rgba(21, 54, 88, 0.04);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 54, 88, 0.08);
}

.stat-item:hover .stat-number {
  transform: scale(1.05);
  background: linear-gradient(135deg, #1a4370 0%, #153658 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.lawyer-stats {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
  padding: 1.5rem;
  background: rgba(21, 54, 88, 0.02);
  border-radius: 16px;
  border: 1px solid rgba(21, 54, 88, 0.05);
  box-shadow: 0 4px 20px rgba(21, 54, 88, 0.03);
}

@media (max-width: 768px) {
  .lawyer-stats {
    flex-direction: column;
    gap: 1rem;
  }
  
  .stat-item {
    padding: 1rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
}
</style>

<!-- Add margin-top to account for fixed navbar -->
<div class="coleta-advogado-container" style="margin-top: 76px;">
  <div class="container">
    <h1 class="text-center mb-5">Cadastro de Advogado</h1>
    <div class="row">
      <!-- Lado Esquerdo - Chamadas para Ação -->
      <div class="col-md-6">
        <div class="info-section">
          <!-- Chamada para Advogados -->
          <div class="cta-card lawyer-cta">
            <div class="lawyer-header">
              <i class="fas fa-balance-scale lawyer-icon" style="color: #153658;"></i>
              <h2>Junte-se à Nossa Equipe de Advogados</h2>
              <p class="subtitle">Seja parte de uma rede de profissionais especializados em direito imigratório</p>
            </div>

            <div class="benefits">
              <div class="benefit-grid">
                <div class="benefit-item">
                  <i class="fas fa-users" style="color: #153658;"></i>
                  <h4>Novos Clientes</h4>
                  <p>Acesso a uma rede crescente de clientes</p>
                </div>
                <div class="benefit-item">
                  <i class="fas fa-tasks" style="color: #153658;"></i>
                  <h4>Gestão Simplificada</h4>
                  <p>Plataforma intuitiva para gerenciar processos</p>
                </div>
                <div class="benefit-item">
                  <i class="fas fa-money-bill-wave" style="color: #153658;"></i>
                  <h4>Pagamentos Garantidos</h4>
                  <p>Receba seus honorários com segurança</p>
                </div>
                <div class="benefit-item">
                  <i class="fas fa-headset" style="color: #153658;"></i>
                  <h4>Suporte Dedicado</h4>
                  <p>Equipe de suporte sempre disponível</p>
                </div>
              </div>
            </div>

            <div class="lawyer-stats">
              <div class="stat-item">
                <span class="stat-number">300+</span>
                <span class="stat-label">Advogados Ativos</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">800+</span>
                <span class="stat-label">Processos Mensais</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">97%</span>
                <span class="stat-label">Satisfação</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Lado Direito - Formulário de Cadastro -->
      <div class="col-md-6">
        <div class="form-section">
          <div class="registration-message">
            <h2>Cadastro de Advogado</h2>
            <p class="lead">Preencha o formulário ao lado para se juntar à nossa equipe de advogados especializados.</p>
          </div>

          <form [formGroup]="advogadoForm" (ngSubmit)="onSubmit()" class="form-container">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="cognome">Cognome:</label>
                  <input 
                    type="text" 
                    id="cognome" 
                    formControlName="cognome" 
                    class="form-control"
                    placeholder="Digite o cognome">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="nome">Nome:</label>
                  <input 
                    type="text" 
                    id="nome" 
                    formControlName="nome" 
                    class="form-control"
                    placeholder="Digite o nome">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="telefono">Telefone:</label>
                  <input 
                    type="text" 
                    id="telefono" 
                    formControlName="telefono" 
                    class="form-control"
                    placeholder="+39 XXX XXX XXXX"
                    [textMask]="{mask: telefoneMask}">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-mail:</label>
                  <input 
                    type="email" 
                    id="email" 
                    formControlName="email" 
                    class="form-control"
                    placeholder="seu@email.com">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="pec">PEC:</label>
                  <input 
                    type="email" 
                    id="pec" 
                    formControlName="pec" 
                    class="form-control"
                    placeholder="seu@pec.it">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="cf">Codice Fiscale:</label>
                  <input 
                    type="text" 
                    id="cf" 
                    formControlName="cf" 
                    class="form-control"
                    placeholder="XXXXXX00X00X000X"
                   >
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="piva">Partita IVA:</label>
                  <input 
                    type="text" 
                    id="piva" 
                    formControlName="piva" 
                    class="form-control"
                    placeholder="00000000000"
                    [textMask]="{mask: pivaMask}">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="indirizzo">Indirizzo Studio:</label>
                  <input 
                    type="text" 
                    id="indirizzo" 
                    formControlName="indirizzo" 
                    class="form-control"
                    placeholder="Digite o endereço do escritório">
                </div>
              </div>
            </div>

            <div class="form-group checkbox-group">
              <label class="mb-2">Línguas:</label>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-check">
                    <input type="checkbox" id="linguaPortoghese" formControlName="linguaPortoghese" class="form-check-input">
                    <label for="linguaPortoghese" class="form-check-label">Português</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input type="checkbox" id="linguaSpagnolo" formControlName="linguaSpagnolo" class="form-check-input">
                    <label for="linguaSpagnolo" class="form-check-label">Espanhol</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input type="checkbox" id="linguaInglese" formControlName="linguaInglese" class="form-check-input">
                    <label for="linguaInglese" class="form-check-label">Inglês</label>
                  </div>
                </div>
              </div>
              <div class="text-danger mt-1" *ngIf="hasLanguageError">
                Selecione pelo menos uma língua
              </div>
            </div>

            <div class="form-group checkbox-group mt-4">
              <label class="mb-2">Cassazionista:</label>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-check">
                    <input type="radio" id="cassazionistaSim" formControlName="cassazionista" [value]="true" class="form-check-input">
                    <label for="cassazionistaSim" class="form-check-label">Sì</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check">
                    <input type="radio" id="cassazionistaNo" formControlName="cassazionista" [value]="false" class="form-check-input">
                    <label for="cassazionistaNo" class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <button type="submit" class="btn btn-primary w-100" [disabled]="!advogadoForm.valid">
                <i class="fas fa-save me-2"></i>
                Enviar Cadastro
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Sucesso -->
<ng-template #successModal>
  <div class="modal-header">
    <h4 class="modal-title">Cadastro Realizado com Sucesso!</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body text-center">
    <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
    <p class="mt-3">Seu cadastro foi realizado com sucesso! Em breve entraremos em contato para mais informações.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modalService.dismissAll()">OK</button>
  </div>
</ng-template>

<!-- Modal de Erro -->
<ng-template #errorModal>
  <div class="modal-header">
    <h4 class="modal-title">Erro no Cadastro</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body text-center">
    <i class="fas fa-exclamation-circle text-danger" style="font-size: 4rem;"></i>
    <p class="mt-3">Ocorreu um erro ao realizar seu cadastro. Por favor, tente novamente mais tarde.</p>
    <p class="mt-3">{{errorMessage}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Fechar</button>
  </div>
</ng-template> 